// routes/DemoRequestRoutes.js

import React from 'react';
import { Route } from 'react-router-dom';
import MainLayout from '../layouts/MainLayout';
import Watchboard from '../components/Frontend/Watchboard/Watchboard';

export const watchboardRoutes = (
  <Route path="/watchboard" element={<MainLayout />}>
    <Route index element={<Watchboard />} />
  </Route>
);
